module.exports = __webpack_public_path__ + "assets/img/d2ea-td.svg";